"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var route_1 = __importDefault(require("@/Modules/Misc/route"));
var ItemShipmentFormPage = /** @class */ (function (_super) {
    __extends(ItemShipmentFormPage, _super);
    function ItemShipmentFormPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = [];
        _this.processing = false;
        _this.search = "";
        _this.form = {
            courier: "",
            trackingNumber: "",
            shipmentDate: null,
            estDeliveryDate: null,
        };
        _this.showShipmentDatePopover = false;
        _this.showEstDeliveryDatePopover = false;
        return _this;
    }
    Object.defineProperty(ItemShipmentFormPage.prototype, "showTrackingNumber", {
        get: function () {
            var _this = this;
            var search = this.couriers.filter(function (x) { return x.value == _this.form.courier; });
            var condition = search.length == 1 ? !lodash_1.default.isEmpty(search[0].trackingLink) : false;
            return this.form.courier && condition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemShipmentFormPage.prototype, "estimatedDeliveryDateNotSame", {
        get: function () {
            if (this.item.shipping_estimated_delivery_date) {
                return this.form.estDeliveryDate && (0, moment_1.default)(this.item.shipping_estimated_delivery_date).date() != this.form.estDeliveryDate.getDate();
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemShipmentFormPage.prototype, "courierNotSame", {
        get: function () {
            return (this.form.courier != this.item.shipping_courier && this.item.shipping_courier);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemShipmentFormPage.prototype, "trackingNumberNotSame", {
        get: function () {
            return this.item.shipping_tracking_number && this.showTrackingNumber && this.form.trackingNumber != this.item.shipping_tracking_number;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemShipmentFormPage.prototype, "enableSubmit", {
        get: function () {
            if (!this.item.is_shipped) {
                return true;
            }
            else {
                return this.form.isDirty;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemShipmentFormPage.prototype, "shippingAddress", {
        get: function () {
            var string = "";
            if (this.item.shipping_address) {
                if (this.item.shipping_address.street) {
                    string += this.item.shipping_address.street;
                }
                if (this.item.shipping_address.street2) {
                    string += (string.length ? "<br />" : "");
                    string += this.item.shipping_address.street2;
                }
                if (string.length && (this.item.shipping_address.city || this.item.shipping_address.state || this.item.shipping_address.zip)) {
                    string += "<br />";
                }
                if (this.item.shipping_address.city) {
                    string += this.item.shipping_address.city;
                    if (this.item.shipping_address.state) {
                        string += ", ";
                    }
                    else if (this.item.shipping_address.zip) {
                        string += " ";
                    }
                }
                if (this.item.shipping_address.state) {
                    string += this.item.shipping_address.state;
                    if (this.item.shipping_address.zip) {
                        string += " ";
                    }
                }
                if (this.item.shipping_address.zip) {
                    string += this.item.shipping_address.zip;
                }
            }
            return string;
        },
        enumerable: false,
        configurable: true
    });
    ItemShipmentFormPage.prototype.add = function () {
        this.options.push({
            name: this.search,
            value: this.search,
            trackingLink: null,
        });
    };
    ItemShipmentFormPage.prototype.send = function () {
        var _this = this;
        this.processing = true;
        this.form
            .transform(function (data) { return (__assign(__assign({}, data), { shipmentDate: _this.form.shipmentDate ? (0, moment_1.default)(_this.form.shipmentDate).format("YYYY-MM-DD") : "", estDeliveryDate: _this.form.estDeliveryDate ? (0, moment_1.default)(_this.form.estDeliveryDate).format("YYYY-MM-DD") : "" })); })
            .post((0, route_1.default)("admin.board.item.shipment.update", {
            board: this.board.abbr,
            item: this.item.hash_id,
        }), {
            onSuccess: function (response) {
                var flash = response.props.flash;
                _this.$toast.success(flash.message);
                _this.processing = false;
            },
            onError: function (error) {
                console.error(error);
                _this.processing = false;
            }
        });
    };
    ItemShipmentFormPage.prototype.created = function () {
        this.options = lodash_1.default.cloneDeep(this.couriers);
        this.form.shipmentDate = this.item.shipping_date ? (0, moment_1.default)(this.item.shipping_date).toDate() : (0, moment_1.default)().toDate();
        this.form.estDeliveryDate = this.item.shipping_estimated_delivery_date ? (0, moment_1.default)(this.item.shipping_estimated_delivery_date).toDate() : null;
        this.form.courier = this.item.shipping_courier;
        this.form.trackingNumber = this.item.shipping_tracking_number;
        this.form = this.$inertia.form(this.form);
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Array })
    ], ItemShipmentFormPage.prototype, "couriers", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Object })
    ], ItemShipmentFormPage.prototype, "board", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Object })
    ], ItemShipmentFormPage.prototype, "item", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Boolean })
    ], ItemShipmentFormPage.prototype, "enabled", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Object })
    ], ItemShipmentFormPage.prototype, "errors", void 0);
    ItemShipmentFormPage = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {},
        })
    ], ItemShipmentFormPage);
    return ItemShipmentFormPage;
}(vue_property_decorator_1.Vue));
exports.default = ItemShipmentFormPage;
